/*
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2022-02-10 14:11:16
 * @FilePath: \Siui.Cloud.Medical.Web\src\lang\zh.js
 */

export default {
	// Common
	tips: "提示",
	yes: "是",
	no: "否",
	search: "搜索",
	reset: "重置",
	edit: "编辑",
	delete: "删除",
	// 路由
	route: {
		SIUICloud: "宏云",
		home: "主页",
		modifyPassword: "修改密码",
		accountSetting: "账号设置",
		authentication: "专家认证",
		feedback: "建议反馈",
		userSetting: "用户设置",
		cloudStorage: "云存储",
		myFiles: "我的文档",
		myReport: "我的报告",
		reportTemplate: "报告模板",
		reportThesaurus: "报告词库",
		comparison: "对比模式",
		cloudConsultation: "云咨询",
		createConsultation: "新建咨询",
		myConsultation: "我的咨询",
		receiveConsultation: "收到咨询",
		cloudTeaching: "云教学",
		cloudResourceManagement: "云资源管理",
		resourcePreview: "资源预览",
		cloudService: "云客服",
		messageList: "消息列表",
		staffList: "工程师列表",
		mai: "麦粒医生",
		couponManagement: "卡券管理",
		IntegralRules: "积分规则",
		integralMapping: "积分规则映射",
		previewResource: '浏览资料',
		liveReview: "往期回顾",
		liveManagement: "直播管理",
		liveList: "直播列表",
		liveConfiguration: "直播配置",
		ADManagement: "广告管理",
		liveAudienceList: "观众列表",
		liveMemberList: "成员列表",
		hierarchicalDiagnosis: "分级诊疗",
		ultrasonic: "超人圈",
		ultrasonicDetail: "超人圈 / 话题详情",
		ultrasonicGroups: "超人圈群组",
		ultrasonicGroupsDetail: "超人圈群组详情",
		ultrasonicGroupsMember: "超人圈组内成员",
		ultrasonicGroupsPost: "超人圈组内话题",
		eventSquare: "活动广场",
		eventDetail: "活动详情",
		videoCourse: "视频课程",
		videoDetail: "视频详情",
		quizManagement: "问答管理",
		quizDetail: "问题详情",
		CarouselManagement: "轮播管理",
		ModuleManagement: "栏目管理",
		ModuleCustomization: "模块定制",
		NotificationManagement: "通知管理",
		customerService: "在线客服",
		statisticsManagement: "统计管理",
		integralStatistics: "麦粒统计",
		liveStatistics: "直播统计",
		statistics: "数据统计",
		userStatistics: "用户统计",
		appManagement: "应用管理",
		versionManagement: "版本管理",
		downloadManagement: "下载管理",
		systemManagement: "系统管理",
		RoleManagement: "角色管理",
		authorityManagement: "权限管理",
		PermissionList: "权限列表",
		instrumentManagement: "设备管理",
		staffManagement: "客服管理",
		expertManagement: "专家管理",
		userManagement: "用户管理",
		netDiskManagement: "云盘文件管理",
		diagnosisManagement: "会诊管理",
		roleApplicationManagement: "会诊角色申请管理",
		roleUserManagement: "会诊角色用户管理",
		teamManagement: "会诊团队管理",
		diagnosticTeamDetail: "会诊团队详情",
		diagnosticTeamMember: "会诊团队成员管理",
		diagnosticUserDetail: "会诊角色详情",
		resourceManagement: "内部资源管理",
		productionInfoManagement: "产品资料管理",
		tagManagement:"筛选条件管理",
		uploadFile:"上传产品资料",
		fileDetail:"编辑产品资料",
		manageFileType:"资料类型管理",
		classificationManagement:"筛选条件管理",
		uploadLearningFile:"上传学习资源",
		learningMaterialsManagement: '学习资源管理',
		userDetail: "用户详情",
		userFeedback: "用户反馈",
		contentSecurity: "内容安全",
		contactUs: "联系我们",
		officialWebsite: "官方网站",
		CSDocumentManagement: "客服文档管理",
		file: "文档管理",
		user: "用户（待关闭）",
		resourceApply:"资源访问申请",
		accessConfig:"访问权限设置",
		FileManagement: "文件管理",
		ConditionDetail:"分类属性设置",
	},

	// 登录&注册
	login: {
		language: "语言",
		zh: "中文",
		en: "英文",
		SIUICloudLogin: "宏云",
		username: "用户名",
		usernameTips: "请输入正确的用户名",
		password: "密码",
		passwordTips: "密码不能少于6位数字",
		login: "登录",
		logout: "退出登录",
		registered: "注册",
		forgetPassword: "忘记密码",
	},

	// 主页
	home: {},

	// 云存储
	cloudStorage: {},

	// 云咨询
	cloudConsultation: {},

	// 云教学
	cloudTeaching: {},

	// 云客服
	cloudService: {},

	// 麦粒医生
	mai: {},

	// 统计管理
	statisticsManagement: {},

	// 应用管理
	appManagement: {},

	// 系统管理
	systemManagement: {
		// CS Document
		CSDocument: {
			fileList: "文件列表",
			resourceType: "资料类型管理",
			filterCondition: "分类管理", //原筛选条件管理
			instrumentSeries: "设备机型管理",
			userApply:"用户绑定审核",
			userList: "用户列表",
			userReview: "设备用户授权管理",
			userApplication: "用户申请",
			userRecord: "浏览记录",
			userRole: "文档访问角色",
			view: "查看",
			download: "下载",
			approve: "批准",
			unapprove: "不批准",
		},
	},

	// 联系我们
	contactUs: {},
};
